import React from 'react'
import './Home.css'
import tabletop from './images/home/tabletop.png'
import encyclopedia from './images/home/encyclopedia.png'
import dice from './images/home/dice.png'
import line from './images/home/line.png'
import HomeCarousel2 from '../HomeCarousel'
import Suggestion from './Suggestion'
import recent_game1 from './images/home/9.png'
import recent_game2 from './images/home/4.jpg'
import recent_game3 from './images/home/2.jpg'


function Home() {
  return (
    <div class="background">
      <div class="container">
        <div class="banner">
          <div className='container  d-inline'>
            <div className='homepageText'>
              <div className='row justify-content-md-center container'>
                <img src={tabletop} className="tabletop" id="tabletop"></img>
              </div>
              <div className='row container justify-content-md-center'>
                <img src={encyclopedia} className='encyclopedia' id="encyclopedia"></img>
              </div>
              <div className='row container justify-content-md-center'>
                <img src={dice} className='dice'></img>
              </div>
              <div className='row container justify-content-md-center'>
                <img src={line} className='line2'></img>
              </div>
              
              <div class="container homepageTextAnimate">
                <div class="row">
                  <div class="col">
                    <h2>Recent Reviews</h2>
                  </div>
                  <div class="col bg-8">
                    <h2> Most recent game added </h2>
                    <div class="slide-recent">
                          <a href="/Hanabi"> 
                          <img src={recent_game1} className='recent_game1' id="recent_game1"></img>
                          </a>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">


    
                  </div>
                  <div class="col">


                  <div class="container">
                    <div class="row">
                      <div class="col">
                       
                      </div>

            
                    </div>
                  </div>


    
                  </div>
                </div>
              </div>

    
            </div>
          </div>

        </div>

      </div>
            <HomeCarousel2 />
      {/* <Suggestion /> */}
    </div>
  )
}

export default Home
